import React, { useEffect } from 'react'

const Slideshow = ({ slides, name }: any) => {
  let slideIndex = 1

  const plusDivs = (n: number) => {
    showDivs((slideIndex += n))
  }

  const showDivs = (n: number) => {
    let slideImg: any = document.querySelectorAll(`.${name} .slide-img`)
    if (n > slideImg.length) {
      slideIndex = 1
    }
    if (n < 1) {
      slideIndex = slideImg.length
    }
    for (let i = 0; i < slideImg.length; i++) {
      slideImg[i].style.display = 'none'
    }
    slideImg[slideIndex - 1].style.display = 'block'
  }

  useEffect(() => {
    showDivs(slideIndex)
  }, [])

  return (
    <div className={`${name} slide-container mt-3`}>
      {slides[0]?.image && (
        <img
          className="slide-img"
          src={slides[0].image}
        />
      )}
      {slides[1]?.image && (
        <img
          className="slide-img"
          src={slides[1].image}
        />
      )}
      {slides[2]?.image && (
        <img
          className="slide-img"
          src={slides[2].image}
        />
      )}

      <button
        className="arrow-btn left"
        onClick={() => plusDivs(-1)}
      >
        &#10094;
      </button>
      <button
        className="arrow-btn right"
        onClick={() => plusDivs(1)}
      >
        &#10095;
      </button>
    </div>
  )
}

export default Slideshow
